<template>
    <div class="modal" :class="{'is-active':isActiveWeatherJsonModal}">
        <div @click="$emit('closeWeatherJsonModal')" class="modal-background"></div>
        <div class="modal-content" style="width: 60%;height: 70%">
        <div class="modal-header">
          <div class="header-content">
            <div class="header-left">
              <h2 class="modal-title">{{headerFlightText}} - Weather info from Jetplan</h2>
            </div>
            <button class="close-btn" @click="$emit('closeWeatherJsonModal')" >
              <font-awesome-icon icon="times" />
            </button>
          </div>
        </div>

            <section class="modal-card-body">
                <pre v-if="S_WNReqJetP_Data && S_WNReqJetP_Data.weatherNote">{{S_WNReqJetP_Data.weatherNote}}</pre>
                <div v-for="post in DataList" :key="post.idx">
                    <div v-if="post.WeatherText != null">

                        <pre> {{post.WeatherText}} </pre>
                    </div>
                    <div v-else-if="post.WeatherText == null && post.AirportIcao != ''">
                        <pre> <span style="color: red">{{post.AirportIcao}} : weather data not found. </span> </pre>
                    </div>
                </div>
            </section>

               <footer class="modal-card-foot">
            </footer>
        </div>
    </div>
</template>

<script>
    export default
    {

        name: "WeatherJsonModal",

        data()
        {

            return {

            }

        },

        props: ['isActiveWeatherJsonModal','WRJsonData','S_WNReqJetP_Data', "headerFlightText"],

        created() {



        },

        computed : {

            DataList: function(){

                if (this.WRJsonData != null)
                {

                    return this.WRJsonData.LIST_USED_AIRPORTS;

                }
                else {
                    return "";
                }

            }


        },

        mounted() {

                document.body.addEventListener('keyup', e =>{
                    if (e.keyCode === 27) { //ESC

                        this.isloadedstat =0;
                        this.$emit('closeWeatherJsonModal');

                    }
                })

        },

        methods: {}

    }
</script>

<style scoped>

</style>
